export default __webpack_public_path__ + "static/media/specs-dialog-2.15d5344c.png";